import React, { useCallback } from 'react';
import { Container, Grid, Link, Typography } from '@material-ui/core';
import Breadcrumbs from 'src/components/Breadcrumbs';
import SearchResultsCard from './components/SearchResultsCard';
import { SearchContextProvider } from './hooks/useGlobalSearch';

const Search = ({ location: { search, hash }, history }) => {
  const searchParams = new URLSearchParams(search);
  const query = searchParams.get('query') || '';

  const handleChangeHash = useCallback(
    (newHash: string) => {
      history.push({
        pathname: '/dashboard/search',
        search: `?query=${query}`,
        hash: newHash,
      });
    },
    [history, query]
  );

  const handleChangeQuery = useCallback(
    (newQuery: string) => {
      history.push({
        pathname: '/dashboard/search',
        search: `?query=${newQuery}`,
        hash,
      });
    },
    [history, hash]
  );

  return (
    <Container maxWidth='lg'>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant='h5' gutterBottom>
                Recherche globale
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Breadcrumbs>
                <Link href='/dashboard'>Dashboard</Link>
                <Typography color='inherit'>Recherche</Typography>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <SearchContextProvider defaultQuery={query}>
            <SearchResultsCard
              query={query}
              onChangeQuery={handleChangeQuery}
              pageHash={hash}
              onChangePageHash={handleChangeHash}
            />
          </SearchContextProvider>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Search;
